import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Spin, DatePicker,Upload,Col,Row } from 'antd';
import { getSelectOptionsWithOrWithoutImg } from '../../../utils/options';
import { UserOutlined } from '@ant-design/icons';
import styles from '../Profile.module.css';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { showApiErrors } from '../../../utils/showApiErrors';

import { openErrorNotification } from '../../../utils/notifications';
import moment from 'moment';
import { useContext } from 'react';
import { CompaniesAndCountriesContext } from '../../../contexts/companiesAndCountriesContext';

const dateFormat = 'DD-MM-YYYY';
export const CompanyDetails = ({ initialData, updateCompany }) => {
  const { companies, countries } = useContext(CompaniesAndCountriesContext);
  const [form] = Form.useForm();
  const [selectedImage, setSelectedImage] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const { name, reg_no,vat_no, address,postal_code, city, country, website, contact_person, contact_phone,contact_mail,bank_account,base64_logo } = initialData;
    if(base64_logo){
    setSelectedImage(base64_logo);
    }
    form.setFieldsValue({
      name,  
      reg_no,
      vat_no,
      address,
      postal_code,
      city,
      country,
      website,
      contact_person,
      contact_phone,
      contact_mail,
      bank_account
    });
  }, [form, initialData]);
  const onSubmit = async (values) => {
    if(selectedImage){
      values.base64_logo = selectedImage;

    }
    setLoading(true);
    await updateCompany(values);
    setLoading(false);
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  const handleImageRemove = (file)=>{ 
    setSelectedImage(null);

  };
  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };
  const handleImageChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(false);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl =>
        {
        setSelectedImage(imageUrl);
        setLoading(false);
        }
      );
    }
  };
  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      openErrorNotification({message:'File mora biti JPG/PNG!',duration:8});
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      openErrorNotification({message:'Logo mora biti manji od 2M!',duration:8});
    }
    return isJpgOrPng && isLt2M;
  }

  return (
    <div>
      <h2 className={styles.headingCompany}>
        <UserOutlined /> Uredi podatke firme
      </h2>
      <Spin spinning={loading} wrapperClassName={styles.companyDetailsSpin}>
        <Form {...layout}
          form={form}
          name="userForm"
          onFinish={onSubmit}
          onFinishFailed={({ errorFields }) => {
            form.scrollToField(errorFields[0].name);
          }}
        >
          <div className={styles.companyDetailsContainer}>
          <div>
              <Upload
        name="avatar"
        listType="picture-card"
        className={styles.avatarUplouder}
        showUploadList={false}
        customRequest={dummyRequest}
        beforeUpload={beforeUpload}
        onRemove= {handleImageRemove}
        onChange={handleImageChange}
      >
        {selectedImage ? <img src={selectedImage} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
    </Upload>
    </div>


            <div className={styles.companyDetailsForm}>


              <Row>
              <Col span={12} className={styles.gutterBox}>
              <Form.Item
                label="Naziv"
                name="name"
              >
                <Input
                  placeholder="Naziv"
                  disabled
                />
              </Form.Item>
              </Col>
              <Col span={12} className={styles.gutterBox}>

               
              <Form.Item
                label="Kontakt osoba"
                name="contact_person"
                rules={[
                  {
                    validator: async (rule, value) => {
                      if (value.length > 70) {
                        throw new Error('Dozvoljeno 70 karaktera!');
                      }
                    }
                  },
                  {
                    required: true,
                    message: 'Popunite polje!'
                  }
                ]}
              >
                <Input placeholder="Kontakt osoba" maxLength={70} />
              </Form.Item>
             

              </Col>
              </Row>
              <Row>
              <Col span={12} className={styles.gutterBox}>

              <Form.Item
                label="PIB"
                name="reg_no"
              >
                <Input
                  placeholder="PIB"
                  disabled
                />
              </Form.Item>

               
                </Col>
              <Col span={12} className={styles.gutterBox}>
              <Form.Item
                label="Kontakt e-mail"
                name="contact_mail"
                rules={[
                  {
                    validator: async (rule, value) => {
                      if (value.length > 70) {
                        throw new Error('Dozvoljeno 70 karaktera!');
                      }
                    }
                  },
                  {
                    required: true,
                    message: 'Popunite polje!'
                  }
                ]}
              >
                <Input placeholder="Email" maxLength={70} />
              </Form.Item>
            
                </Col>
              </Row>
              <Row>
              <Col span={12} className={styles.gutterBox}>
              <Form.Item
                  label="PDV"
                  name="vat_no"
                >
                  <Input
                    placeholder="PDV"
                    disabled
                  />
                </Form.Item> 
             
              </Col>
              <Col span={12} className={styles.gutterBox}>
 
              <Form.Item
                label="Broj telefona"
                name="contact_phone"
                rules={[
                  {
                    required: true,
                    message: 'Popunite polje!'
                  }
                ]}
              >
                <Input placeholder="Broj telefona" maxLength={60} />
              </Form.Item>

            

              </Col>
              </Row>
              <Row>
              <Col span={12} className={styles.gutterBox}>
              <Form.Item
                label="Broj račun"
                name="bank_account"
                rules={[
                  {
                    validator: async (rule, value) => {
                      if (value.length > 50) {
                        throw new Error('Dozvoljeno 50 karaktera!');
                      }
                    }
                  },
                  {
                    required: true,
                    message: 'Popunite polje!'
                  }
                ]}
              >
                <Input placeholder="Bank account" maxLength={50} />
                </Form.Item>

              </Col>
             
              </Row>
              <Row>
              <Col className={styles.gutterBox} span={12} >
              <Form.Item
                label="Adresa"
                name="address"
                rules={[
                  {
                    validator: async (rule, value) => {
                      if (value.length > 100) {
                        throw new Error('Dozvoljeno 1-0 karaktera!');
                      }
                    }
                  },
                  {
                    required: true,
                    message: 'Popunite polje!'
                  }
                ]}
              >
                <Input placeholder="Adresa" maxLength={100} />
                </Form.Item>
         
              </Col>
             
              </Row>
              <Row>
              <Col span={12} className={styles.gutterBox}>
              
              <Form.Item
                label="Grad"
                name="city"
                rules={[
                  {
                    validator: async (rule, value) => {
                      if (value.length > 60) {
                        throw new Error('Dozvoljeno 60 karaktera!');
                      }
                    }
                  },
                  {
                    required: true,
                    message: 'Popunite polje!'
                  }
                ]}
              >
                <Input placeholder="Grad" maxLength={60} />
              </Form.Item>
                </Col>
             
              </Row>
              <Row>
          

              <Col span={12} className={styles.gutterBox}>

                  <Form.Item
                className={styles.fullWidth}

                label="Država"
                name="country"
                rules={[
                  {
                    required: true,
                    message: 'Popunite polje!'
                  }
                ]}
              >
                <Select
                  showSearch
                  dropdownClassName={countries ? styles.selectDropdownWithImg : styles.hideSelectDropdown}
                  optionFilterProp="data-searchvalue"
                  showArrow={false}
                  placeholder="Izaberite zemlju"
                  notFoundContent={'Nema rezultata'}
                >
                  {getSelectOptionsWithOrWithoutImg(countries || [])}
                </Select>
              </Form.Item>


              </Col>
              <Col className={styles.gutterBox} span={12} >
             
             <Form.Item className={styles.ConfirmInfoChangesItem} >
               <Button className={styles.confirmInfoChangesBtn} type="primary" htmlType="submit">
                 Sačuvaj izmjene
               </Button>
             </Form.Item>


             </Col>
              </Row>



            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};
